<h2 mat-dialog-title>Backup Config</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <div class="details">
    <h2>Targets</h2>
    <div class="targets column">
      @for (target of targets; track $index) {
        @if (target.items.length) {
          <div class="target-type column">
            <span>{{ target.title }}</span>
            @for (item of target.items; track item) {
              <b>{{ item }}</b>
            }
          </div>
        }
      }
    </div>
    <div class="config-header row">
      <h5>Backup Config</h5>
      <button
        class="button"
        [cdkCopyToClipboard]="data.config | json"
        (cdkCopyToClipboardCopied)="onCopied($event)"
      >
        <fa-icon [icon]="['far', 'copy']" size="lg"></fa-icon>
      </button>
    </div>

    <pre class="config">{{ data.config | json }}</pre>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()">
    <fa-icon [icon]="['fas', 'download']" size="lg"></fa-icon>
    Download
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
